export default __webpack_public_path__ + "static/media/bti-icon-active.5c9759b7.svg";